/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddFilenetSubscriptionProps } from '../models/AddFilenetSubscriptionProps';
import type { FetchActiveFilenetSubscriptionResp } from '../models/FetchActiveFilenetSubscriptionResp';
import type { FetchFilenetSubscriptionHistoryResp } from '../models/FetchFilenetSubscriptionHistoryResp';
import type { FetchFilenetURLResp } from '../models/FetchFilenetURLResp';
import type { FilenetBaseResponse } from '../models/FilenetBaseResponse';
import type { UpdateFilenetSubscriptionProps } from '../models/UpdateFilenetSubscriptionProps';
import type { UpdateFilenetURLProps } from '../models/UpdateFilenetURLProps';
import { request as __request } from '@openapi/request';

export class FilenetConfigurationService {

    /**
     * @returns FetchFilenetSubscriptionHistoryResp Get subscripition history
     * @throws ApiError
     */
    public static async getSubscriptionHistory(): Promise<FetchFilenetSubscriptionHistoryResp> {
        const result = await __request({
            method: 'GET',
            path: `/web/api/filenet-configuration/filenet/subscriptions`,
        });
        return result.body;
    }

    /**
     * @returns FetchActiveFilenetSubscriptionResp Get active subscription
     * @throws ApiError
     */
    public static async getActiveSubscription(): Promise<FetchActiveFilenetSubscriptionResp> {
        const result = await __request({
            method: 'GET',
            path: `/web/api/filenet-configuration/filenet/subscriptions/active`,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns FilenetBaseResponse Add new filenet subscription
     * @throws ApiError
     */
    public static async addNewSubscription(
        requestBody: AddFilenetSubscriptionProps,
    ): Promise<FilenetBaseResponse> {
        const result = await __request({
            method: 'POST',
            path: `/web/api/filenet-configuration/filenet/subscriptions/subscribe`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns FilenetBaseResponse Extend filenet subscription
     * @throws ApiError
     */
    public static async updateSubscription(
        requestBody: UpdateFilenetSubscriptionProps,
    ): Promise<FilenetBaseResponse> {
        const result = await __request({
            method: 'POST',
            path: `/web/api/filenet-configuration/filenet/subscriptions/extend`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @returns FetchFilenetURLResp Get active filenet URL
     * @throws ApiError
     */
    public static async getActiveFilenetUrl(): Promise<FetchFilenetURLResp> {
        const result = await __request({
            method: 'GET',
            path: `/web/api/filenet-configuration/filenet/subscriptions/filenet-url`,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns FilenetBaseResponse Manage filenet URL
     * @throws ApiError
     */
    public static async manageFilenetUrl(
        requestBody: UpdateFilenetURLProps,
    ): Promise<FilenetBaseResponse> {
        const result = await __request({
            method: 'POST',
            path: `/web/api/filenet-configuration/filenet/subscriptions/manage-filenet-url`,
            body: requestBody,
        });
        return result.body;
    }

}